import { hanwahaInstance } from '../../shared_elements';

export const getInvoiceAuthUrl = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    const provider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';
    return `/integrations/${provider}/auth-url/${queryString ? `?${queryString}` : ''}`;
};

export const getProductServiceDropdownApi = (lessor_name_id) => {
    const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';
    return `/integrations/${qbProvider}/products-services/?dropdown=true${lessor_name_id ? `&lessor_name_id=${lessor_name_id}` : ''}`;
}

export const getChartOfAccountDropdownApi = (lessor_name_id) => {
    const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';
    return `/integrations/${qbProvider}/chart-of-accounts/?dropdown=true${lessor_name_id ? `&lessor_name_id=${lessor_name_id}` : ''}`;
}

export const getClassesDropdownApi = (lessor_name_id) => {
    const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';
    return `/integrations/${qbProvider}/classes/?dropdown=true${lessor_name_id ? `&lessor_name_id=${lessor_name_id}` : ''}`;
}

export const getSubClassesDropdownApi = (parent_class_id, lessor_name_id) => {
    const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';
    return `/integrations/${qbProvider}/classes/?dropdown=true${parent_class_id ? `&parent_class_id=${parent_class_id}` : ''}${lessor_name_id ? `&lessor_name_id=${lessor_name_id}` : ''}`;
}

export const getInvoicesApi = (params, query) => {
    const { asset_id, ...rest } = query || {};
    const urlParams = new URLSearchParams();

    Object.entries(rest).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        urlParams.set(key, value);
    });

    let queryString = urlParams.toString();
    if (asset_id?.length) {
        const assetFilter = Array.isArray(asset_id) ? asset_id : asset_id.toString().split(',').filter(Boolean);
        const assetParam = `asset_id=[${assetFilter.join(',')}]`;
        queryString = queryString ? `${queryString}&${assetParam}` : assetParam;
    }

    return `invoices${queryString ? `?${queryString}` : ""}`;
};

export const getInvoiceApi = (params, query) => {
    return `invoices/${params.slug}`;
};

export const changeInvoiceStatusApi = (params, query) => {
    return `invoices/status`;
};

export const revertInvoiceStatusApi = () => {
    return `invoices/status/revert`;
};

// Get Invoice Status Timeline
export const getInvoiceStatusTimelineApi = (params, query) => {
    const queryString = query && Object.keys(query).length ? '?' + new URLSearchParams(query).toString() : '';
    return `invoices/${params.slug}/status-timeline${queryString}`;
};

// constant invoice api
export const getInvoiceConstant = (params) => {
    return `lease/constants/get_by_constant_types`;
}

// POST new Invoice
export const addInvoiceApi = (params) => {
    return `invoices`;
};

// Get Linked Invoice 
export const getLinkedInvoiceApi = (params) => {
    return `invoices/${params.slug}/linked-invoices`
}

// Get Partial Payment
export const getPartialPaymentApi = (params) => {
    return `invoices/${params.slug}/partial-payments`
}

// PUT edit Invoice
export const updatePartiesApi = (params) => {
    return `invoices`;
};

// Get reserve invoice
export const getReserveInvoiceApi = (params, query) => {
    return `invoices/init?master_slug=${params}`;
};

// Get Rental Invoice Period
export const getRentalInvoicePeriodApi = ({ lease_slug, month, year }) => {
    return `rental-invoices/period?lease_slug=${lease_slug}&month=${month}&year=${year}`;
};

// Get reserve invoice
export const getRentalInvoiceApi = ({ lease_slug, period_start_date, period_end_date, master_slug, is_arrears, is_advanced, currency }) => {
    let url = `rental-invoices/init?period_start_date=${period_start_date}&period_end_date=${period_end_date}&lease_slug=${lease_slug}`;

    if (master_slug?.length === 1 && is_arrears === true) {
        url += `&master_slug=${master_slug}&is_arrears=${is_arrears}`;
    }

    if (!master_slug?.length && is_arrears === true) {
        url += `&is_arrears=${is_arrears}`;
    }

    if (is_advanced === true) {
        url += `&is_advanced=${is_advanced}`;
    }

    if (currency) {
        url += `&currency=${currency}`;
    }

    return url;
};

// Get Penalty invoice
export const getPenaltyInvoiceApi = ({ invoiceSlug, late_payment_slug }) => {
    let url = `penalties/init?invoice_slug=${invoiceSlug}&late_payment_interest_slug=${late_payment_slug}`;
    return url;
};

export const getLatePaymentInterestListApi = (lease_slug, query) => {
    return `lease/${lease_slug?.lease_slug}/late-payment-interest/?is_paginate=false}`;
};

//Details
export const utilizationDetailUpdateApi = (leaseSlug, masterSlug) => {
    return `lease/${leaseSlug}/utilizations/${masterSlug}/`;
};


// Post Attachment Api
export const uploadInvoiceAttchment = (slug) => {
    return `lease/invoice/${slug}/attachments`
}

// Delete Invoice Api 
export const deleteInvoiceApi = (params) => {
    return `invoices`
}

// offset dropdown Api
export const offsetDropdownApi = (slug) => {
    return `invoices/offset-dropdown?parent_slug=${slug}`;
};

// Get offset dropdown detail Api 
export const getOffsetDetailApi = (params) => {
    return `invoices/${params}`
}

export const getAssetListApi = (query) => {
    const queryString = new URLSearchParams({ ...query, include_on_wing: true, }).toString();
    return `/api/dropdown/asset/${queryString ? `?${queryString}` : ""}`
}

// Get Offset List
export const getOffsetListApi = (params) => {
    return `invoices/${params.slug}/offset-settlement`
}

// Get Credit Note Offset Adjustment List
export const getCreditNoteOffsetAdjustmentApi = (params) => {
    return `invoices/${params.slug}/credit-note-offset-adjustment`
}

// Get distribution Email List
export const getEmailListApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/api/dropdown/emails/${queryString ? `?${queryString}` : ""}`
}

export const getInvoiceNumberApi = ({ lease_slug, asset_id, asset_type, invoice_type, parent_invoice_type }) => {
    let url = `invoices/number-init?lease_slug=${lease_slug}&asset_id=${asset_id}&asset_type=${asset_type}&invoice_type=${invoice_type}`;

    if (parent_invoice_type) {
        url += `&parent_invoice_type=${parent_invoice_type}`;
    }

    return url;
};

// partoes dropdown Api
export const partyDropdownApi = (slug) => {
    return `api/dropdown/party/?lease_slug=${slug}`;
};

// Get Invoice Rate Items dropdown Api
export const getInvoiceRateItemsApi = ({ lease_slug, invoice_type }) => {
    return `invoices/rate-items?lease_slug=${lease_slug}&invoice_type=${invoice_type}`;
};

//fleet invoce card api
export const getFleetInvCardData = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `invoices/invoice_card${queryString ? `?${queryString}` : ""}`;
};

// lease invoice cad api
export const getLeaseInvCardData = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/invoices/invoice_card/${params?.leaseSlug}${queryString ? `?${queryString}` : ""}`;
}

//bulk invoice status change
export const changeBulkInvoiceStatusApi = (params, query) => {
    return `invoices/status/bulk`;
}
// Get Management Fee Init Api
export const getManagementFeeInitApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/management-fee/init${queryString ? `?${queryString}` : ""}`
}

// additional tax dropdown API
export const getAdditionalTaxDropdownAPI = () => {
    return `additional-tax-settings/management-fee/dropdown`;
};

// Bulk send invoice mail
export const bulkSendInvoiceMailApi = () => {
    return `invoices/bulk-send`;
};

// Get Summary Invoice Init
export const getSummaryInvoiceInitApi = (query = {}) => {
    const queryString = new URLSearchParams(
        Object.fromEntries(
            Object.entries(query).filter(([, v]) => v !== null && v !== undefined && v !== '')
        )
    ).toString().replaceAll('%2C', ',');
    return `summary-invoices/init${queryString ? `?${queryString}` : ''}`;
};

// POST Generate Summary Invoice
export const addSummaryInvoiceApi = () => {
    return `summary-invoices`;
};

// Get Summary Invoice listing
export const getSummaryInvoiceApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `summary-invoices${queryString ? `?${queryString}` : ''}`;
};

// Get Summary Invoice detail
export const getSummaryInvoiceDetailApi = (params) => {
    return `summary-invoices/${params.slug}`;
};

// change status for summary Inv Api
export const changeSummaryInvoiceStatusApi = (slug) => {
    return `summary-invoices/${slug}/status`;
};

// Get Summary Export
export const getSummaryExportApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `summary-invoices/export${queryString ? `?${queryString}` : ''}`;
};

// Get Invoice Approval Report
export const getInvoiceApprovalReportApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/invoice-approval-report/${queryString ? `?${queryString}` : ''}`;
};

// Invoice Approval Flow APIs
export const getInvoiceApprovalDetailsApi = (invoiceSlug) => {
    return `invoices/${invoiceSlug}/invoice-approval-details/`;
};

export const getApprovalWorkingGroupsDropdownApi = (leaseSlug) => {
    const params = new URLSearchParams({ is_members: 'true' })
    if (leaseSlug) params.set('lease_slug', leaseSlug)
    return `invoices/working-groups-dropdown?${params.toString()}`
};

export const sendInvoiceForApprovalApi = (invoiceSlug) => {
    return `invoices/${invoiceSlug}/send-approval-email/`;
};

export const invoiceApprovalActionApi = (invoiceSlug, approvalSlug) => {
    return `invoices/${invoiceSlug}/approval/${approvalSlug}/action/`;
};

export const approvalFlowRivisionHistoryApi = (invoiceSlug) => {
    return `audit-logs/global/history/invoice_approval?invoice_slug=${invoiceSlug}`;
};

export const getApprovalFlowimelineApi = (invoiceSlug, approvalSlug) => {
    return `invoices/${invoiceSlug}/approval/${approvalSlug}/status-timeline/`;
}

export const invoiceApprovalAttachmentApi = (statusHistorySlug) =>
    `invoice-approval-status-history/${statusHistorySlug}/attachments`;

// Titan Multi Approval Flow APIs
export const getMultiApprovalDetailsApi = (invoiceSlug) => {
    return `invoices/${invoiceSlug}/titan/approval-details/`;
};

export const approvalActionApi = (invoiceSlug, approvalSlug) => {
    return `invoices/${invoiceSlug}/titan/approval/${approvalSlug}/action/`;
};

export const getApprovalTimelineApi = (invoiceSlug, approvalSlug) => {
    return `invoices/${invoiceSlug}/titan/approval/${approvalSlug}/status-timeline/`;
};

// lease invoice cad api
export const getLeaseInvCardApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/invoices/v2/invoice_card/${params?.leaseSlug}${queryString ? `?${queryString}` : ""}`;
}

// get rental currency 
export const getRentalRateCurrency = (lease_slug) => {
    return `/rental-invoices/currencies?lease_slug=${lease_slug?.lease_slug}`;
}

export const updateInternalRemarksApi = () => {
    return `invoices/internal-remarks`;
};

export const getInternalRemarksHistoryApi = (params) => {
    return `invoices/${params.slug}/internal-remarks-history`;
};

export const getInvoiceQbSyncHistoryApi = (invoiceId) => {
    return `integrations/hanwha-qb/invoices/${invoiceId}/sync-history/`;
}

// POST bulk management-fee Invoice
export const addManagementFeeApi = (params) => {
    return `management-fee/generate`;
};